import { render, staticRenderFns } from "./SmsCommentField.vue?vue&type=template&id=d6f19f7c&scoped=true"
import script from "./SmsCommentField.vue?vue&type=script&lang=js"
export * from "./SmsCommentField.vue?vue&type=script&lang=js"
import style0 from "./SmsCommentField.vue?vue&type=style&index=0&id=d6f19f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f19f7c",
  null
  
)

export default component.exports